import { servicesAPI } from "./api"

// filter usage
// X:Y => search X in workspace name, then Y in child name
// :example => search only in child name
// example: => search only in workspace name
// example => search in both workspace and child name

export const getWorkspaceFullHierarchy = (
    filter: string,
    offset: number,
    limit: number,
): Promise<Models.NavigationWorkspace[]> =>
    servicesAPI.postJSON("CollectWorkspaceFullHierarchy", {
        filter,
        offset,
        limit,
    })

export const getWorkspaceContent = (
    workspaceId: number,
    filter: string,
    offset: number,
    limit: number,
): Promise<Models.NavigationWorkspaceChild[]> =>
    servicesAPI.postJSON("CollectWorkspaceContent", {
        workspaceId,
        filter,
        offset,
        limit,
    })
